<template>
  <vf-dialog-layout>
    <iframe
      allow="autoplay"
      allowfullscreen
      class="aspect-video"
      height="100%"
      :src="videoUrl"
      :title
      width="100%"
    />
    <vf-button
      :aria-label="$t.close"
      class="mr-4 mt-4 p-2 right-0 top-0 absolute"
      :class="classButton"
      data-test-id="vf-modal-close"
      :variant="buttonVariant"
      @click="$emit('resolve')"
    >
      <vf-icon name="close" size="md" />
    </vf-button>
  </vf-dialog-layout>
</template>

<script lang="ts" setup>
import type { CSSClass, Responsive } from '#types/common'
import type { ButtonVariant } from '#types/components/vf/button'

export type Props = {
  videoUrl: string
  title: string
  buttonVariant?: ButtonVariant | Responsive<ButtonVariant>
  classButton?: CSSClass
}
export type Emits = {
  resolve: []
}

defineProps<Props>()
defineEmits<Emits>()
</script>
